export const GOOGLE_MAP_ZOOM_MAX_VALUE = 16
